import OrderingCard from './OrderingCard';

export default OrderingCard;
